module.exports = __webpack_public_path__ + "img/gallery-post-dark.4dc4cc60.jpg";